import React from "react";
import { Button } from "@mui/material";
import colors from "../../../../../utils/colors";

const OutlinedButton = ({ children, startIcon, onClick, disabled, ...props }) => {
  return (
    <Button
      variant="outlined"
      onClick={onClick}
      disabled={disabled}
      startIcon={startIcon}
      sx={{
        height: 36,
        borderRadius: "8px",
        backgroundColor: "transparent",
        border: "1px solid #6371F7",
        fontSize: 14,
        fontWeight: 400,
        lineHeight: "21px",
        textTransform: "none",
        color: "#6371F7",
        px: 4,
        "&:hover": {
          backgroundColor: "rgba(99, 113, 247, 0.08)",
          borderColor: "#4959ee",
          color: "#4959ee",
        },
        "&:disabled": {
          backgroundColor: "transparent",
          borderColor: colors.neutral[200],
          color: colors.neutral[500],
        },
        ...props.sx,
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

export default OutlinedButton;
